export const fetchCarouselData = async () => {
  try {
    const response = await fetch('./content/home/page-components/hero-shot/hero-shot.json', {
        cache: "no-cache"
    });
    return await response.json();
  } catch (e) {
    console.log(e)
  }
};



// WEBPACK FOOTER //
// ./src/api/fetchCarouselData.js